export enum DynamicFieldType {
    Actions = 1,
    Text = 2,
    Date = 3,
    Number = 4,
    Boolean = 5,
    Color = 6,
    Grid = 7,
    Image = 8,
    Select = 9,
    Currency = 10,
    Hidden = 11,
    Html = 12,
    Password = 13,
    File = 14,
    Chip = 15,
    TextArea = 16,
    Icon = 17,
    ManageImage = 18,
    DragDrop = 19,
    Editor = 20,
    TristateCheckbox = 21,
    Template = 22,
    DivText = 23,
    ToggleButton = 24,
}